import React, { useContext } from 'react'
import { Auth } from 'aws-amplify'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { Navigate, useSearchParams } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'
import { DateTime } from 'luxon'

import { XeroButton } from '../../components/ui/xeroButton/xeroButton'

import BillyLogo from '../../images/billy_logo.svg'
import RightImage from '../../images/right.png'

import './login.css'
import { AppContext } from '../../App'

const Login = () => {
	const { appState, loading } = useContext(AppContext)
	const { authStatus } = useAuthenticator((context) => [context.authStatus])
	const [searchParams] = useSearchParams()

	const redirect = searchParams.get('redirect')

	// Wait for appState to load fully
	if (authStatus === 'authenticated' && appState.authState.isLoggedIn && !loading) {
		if (appState.accounts.length === 0 && appState.hasNoAccount) {
			return <Navigate to="/confirmation" />
		}

		if (redirect) {
			return <Navigate to={redirect} />
		}

		return <Navigate to="/" />
	}

	if (!appState.authState.isLoggedIn) {
		return (
			<Row className="g-0">
				<Col xs={12} md={6} className="login-flex">
					<header className="login-header">
						<img src={BillyLogo} alt="billy by finlert logo" />
					</header>
					<main className="login-main">
						<XeroButton text={'Login with Xero'} onClick={() => Auth.federatedSignIn({ customProvider: 'SignInWithXeroBilly' })} />
					</main>
					<footer className="login-footer">
						<a href="#">Privacy Statement</a>
						<a href="#">Legal Disclaimer</a>
						<span className="body-2">Copyright All Rights Reserved &copy; {DateTime.now().toFormat('yyyy')}.</span>
					</footer>
				</Col>
				<Col md={6} className="d-none d-md-block">
					<img src={RightImage} className="img-fluid" alt="leavecal by finlert product placement" />
				</Col>
			</Row>
		)
	} else {
		return <div></div>
	}
}

export default Login
